// Назначение роли (contracts/api.md 001; 041: без областей и замещения).
import { z } from '../kernel/zod.ts';
import { DateSchema, IdSchema, TimestampSchema, VersionSchema } from '../kernel/common.ts';
import { RoleSchema } from '../rights/roles.ts';

/**
 * Назначение роли «Администратор» или сопровождения: действует во всей установке (041, FR-011).
 * Срок — только у ролей, в которые при обновлении перевели замещение (041, research Р5):
 * «по ДД.ММ.ГГГГ».
 */
export const AssignmentSchema = z.object({
  id: IdSchema,
  userId: IdSchema,
  role: RoleSchema,
  /** Пусто — без ограничения. */
  validFrom: DateSchema.optional(),
  validTo: DateSchema.optional(),
  version: VersionSchema,
  archivedAt: TimestampSchema.optional(),
});
export type Assignment = z.infer<typeof AssignmentSchema>;

/**
 * Состояния замещения — только для подписей старых записей журнала (041: замещения нет).
 * Закончилось — после конца дня validTo в поясе установки.
 */
export const substitutionStates = ['planned', 'active', 'ended', 'cancelled'] as const;
export const SubstitutionStateSchema = z.enum(substitutionStates);
export type SubstitutionState = (typeof substitutionStates)[number];
